module.exports = __webpack_public_path__ + "img/17-15-23.638f7a92.jpg";